import { useState } from "react";
import { RechnungData } from "./rechnungData";
import Confirm, { ConfirmInfo } from "../confirmComponent/confirm";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Container, Form, Modal, Stack, Table } from "react-bootstrap";
import LogoHeader from "../logoHeader/logoHeader";
import { DataHandler } from "../dataHandler";
import { HydroSpinner } from "../spinner/hydroSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faPencilSquare, faSquareCheck } from "@fortawesome/free-solid-svg-icons";

function ListeRechnung() {
    const [rgData, setRgData] = useState<Array<RechnungData> | boolean | undefined>();
    const [error, setError] = useState<string | undefined>();
    const [confirmInfo, setConfirmInfo] = useState<ConfirmInfo>();
    const [showAll, setShowAll] = useState<boolean>(false);
    const navigate = useNavigate();


    const reload = () => {
        setRgData(undefined);
    }

    const createSummaryPDF = () => {
        DataHandler.createRgPDF();
    }

    const closeAll = () =>{

        setConfirmInfo({
            text: 'Alle Rechnungen wirklich abschließen?',
            onConfirmCallback: () => {

                DataHandler.setAllActiveRgInactive().then((data: Array<RechnungData>) => {
                    setRgData(data);
                });
                setConfirmInfo(undefined);
            },
            onAbortCallback: () => {
                setConfirmInfo(undefined);
            }
        });
    }

    if (rgData === undefined) {
        setRgData(true);
        DataHandler.getRechnungList(showAll).then((data: Array<RechnungData>) => {
            setRgData(data);
        }).catch((error) => {
            setRgData(false);
            setError(error);
        });
        return (<HydroSpinner />);
    } else if (rgData === true)
        return (<HydroSpinner />);
    else if (rgData === false)
        return (<Container>
            <LogoHeader />
            <Container>
                <h3>Konnte Daten nicht laden.</h3>
                <Button onClick={reload} variant="primary">Neu laden</Button>
            </Container>
        </Container>)

    let failedHtml;
    if (error) {
        failedHtml = <Modal show={error !== undefined}><Modal.Body><Alert key='danger' variant='danger'>
            Fehler: {error}
        </Alert>
        </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => { setError(undefined) }} >OK</Button>
            </Modal.Footer>
        </Modal>
    }

    const getStateString = (state: number) => {
        if (1 === state)
            return "Neu";
        if (2 === state)
            return "Erledigt";
        return "Unbekannt";
    }

    const getTimeString = (timestamp: number) => {
        const date = new Date(timestamp);
        return <div><div>{date.toLocaleDateString()}</div><div>{date.toLocaleTimeString()}</div></div>
    }

    const setDone = (id: number) => {
        setConfirmInfo({
            text: 'Rechnung wirklich abschließen?',
            onConfirmCallback: () => {

                DataHandler.setRechungDone(id).then((data: Array<RechnungData>) => {
                    setRgData(data);
                });
                setConfirmInfo(undefined);
            },
            onAbortCallback: () => {
                setConfirmInfo(undefined);
            }
        })

    }

    const changeSwitch = () => {
        setRgData(undefined);
        setShowAll(!showAll);
    }


    const edit = (id: number) => {
        navigate("/rg/" + id);
    }

    const back = () => {
        navigate("/");
    }

    let switchLabel = "Alle Rechnungen anzeigen";
    if (showAll)
        switchLabel = "Aktive Rechnungen anzeigen";

    return (
        <Container>
            <Confirm confirmInfo={confirmInfo} />
            <LogoHeader />
            <Form>
                <Form.Switch id="allSwitch" checked={showAll} onChange={changeSwitch} label={switchLabel}></Form.Switch>
            </Form>
            <Table striped bordered hover size="md">
                {failedHtml}

                <thead>
                    <tr>
                        <th>Techniker</th>
                        <th>Status</th>
                        <th>Zeit</th>
                        <th>Beschreibung</th>
                        <th>Aktion</th>
                    </tr>
                </thead>
                <tbody>
                    {rgData.map(data => (
                        <tr className={data.state > 1 ? 'table-light' : 'table-primary'}>
                            <td>{data.json.techniker}</td>
                            <td>{getStateString(data.state)}</td>
                            <td>{getTimeString(data.timestamp)}</td>
                            <td>{data.json.beschreibung}</td>
                            <td>
                                <Stack direction="horizontal" gap={1}>
                                    <Button onClick={() => { edit(data.id) }} variant="secondary">
                                        <FontAwesomeIcon icon={faPencilSquare} className={"left-icon"} />
                                        Rechnung ansehen
                                    </Button>
                                    {data.state < 2 ? <Button onClick={() => { setDone(data.id) }} variant="primary">
                                        <FontAwesomeIcon icon={faSquareCheck} className={"left-icon"} />
                                        Abschließen
                                    </Button> : null}
                                </Stack>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Stack direction="horizontal" gap={3}>
                <Button variant="primary" onClick={reload} >Neu laden</Button>
                <Button variant="secondary" onClick={back}>Zurück</Button>
                {!showAll && <Button variant="success" onClick={createSummaryPDF}>Sammelpdf erstellen</Button>}
                {!showAll && <Button variant="danger" onClick={closeAll}>Aktive Rechnungen abschließen</Button>}
            </Stack>
        </Container>

    )

}
export default ListeRechnung;